module.exports = {
          srcSet: __webpack_public_path__ + "11d7f7043376c715b5c4cc48add8baaf-45.png"+" 45w",
          images:[ {path: __webpack_public_path__ + "11d7f7043376c715b5c4cc48add8baaf-45.png",width: 45,height: 45}],
          src: __webpack_public_path__ + "11d7f7043376c715b5c4cc48add8baaf-45.png",
          toString:function(){return __webpack_public_path__ + "11d7f7043376c715b5c4cc48add8baaf-45.png"},
          
          width: 45,
          height: 45
        }